module.exports = __webpack_public_path__ + "img/intro_no.06c91439.svg";